<div>

  <div class="row">
    <div class="col-md-8">
      <!--Row 1 Start-->
      <div class="row">
        <div class="col"><span><strong>Claim Type:</strong></span><span class="requiredField">*</span></div>
        <div class="col"><span>{{claim.claimTypeName}}</span></div>
        <div class="col"><span><strong>Scheduled Ship Date:</strong></span> </div>
        <div class="col"> <span>{{claim.scheduleDate | date:'MM/dd/yy'}}</span></div>
      </div>
      <!--Row 1 End-->
      <!--Row 2 Start-->
      <div class="row">
        <div class="col"><span><strong>Job Name:</strong></span></div>
        <div class="col"><span>{{claim.jobName}}</span></div>
        <div class="col"><span><strong>Shipped From:</strong></span> </div>
        <div class="col"><span>{{claim.shipFrom}}</span></div>
      </div>
      <!--Row 2 End-->
      <!--Row 3 Start-->
      <div class="row">
        <div class="col"><span><strong>Sales Order #:</strong></span></div>
        <div class="col"><span>{{claim.soNumber}}</span></div>
        <div class="col"><span><strong>Shipped To:</strong></span></div>
        <div class="col"><span>{{claim.shipTo}}</span></div>
      </div>
      <!--Row 3 End-->
      <!--Row 4 Start-->
      <div class="row">
        <div class="col"><span><strong>Customer Name:</strong></span></div>
        <div class="col"><span>{{claim.customerNumber}} - {{claim.customerName}}</span></div>
        <div class="col"><span><strong>Status:</strong></span></div>
        <div class="col"><span>{{claim.statusName}}</span></div>
      </div>
      <!--Row 4 End-->

    </div>
    <div class="col">
      <div class="row">
        <div class="col-md-3">
          <span><strong>Comments:</strong></span>
        </div>
        <!--</div>
        <div class="row">-->
        <div class="col-md-9">
          <span>
       <!--{{claim.comment}}-->
          </span>
        </div>
      </div>
    </div>
  </div>

</div>
<hr />
<div>
  <kendo-grid [data]="trackShipmentTabGridData"
              class="orderInquiryDetailsGridCls"
              [sortable]="true"
              [selectable]="false"
              [navigable]="true"
              [filterable]="true"
              [groupable]="false"
              [reorderable]="true"
              [resizable]="true"
              [sort]="trackShipmentGridstate.sort"
              [pageable]="{ buttonCount: 5, info: true, pageSizes:[50,75,100] }"
              [pageSize]="trackShipmentGridstate.take"
              [skip]="trackShipmentGridstate.skip"
              [columnMenu]="{ filter: false, sort: false }"
              (sort)="trackShipmentGridSortChange($event)"
              (pageChange)="trackShipmentGridPageChange($event)"
              (dataStateChange)="trackShipmentDataStateChange($event)"
              (columnReorder)="onShipmentReorder($event)"
              (columnVisibilityChange)="onShipmentVisibilityChange($event)"
              [filter]="trackShipmentGridstate.filter"
              [loading]="claimItemGridLoading">
    <ng-template kendoGridToolbarTemplate>
      <!--<div class="k-grid-toolbar-button-display hideToolBarBtnInPwa">
        <button kendoButton class="excel-button" icon="file-excel" [disabled]="loadingExcel" (click)="generateShipmentExcel()">
          {{orderDetailTxt.exportToExcelLbl?orderDetailTxt.exportToExcelLbl:orderDetail.exportToExcelLbl}}
          <kendo-loader *ngIf="loadingExcel"></kendo-loader>
        </button>
        <button kendoButton icon="file-pdf" class="pdf-button" [disabled]="loadingPDF" (click)="generateShipmentPDF()">

          {{orderDetailTxt.exportToPdfLbl?orderDetailTxt.exportToPdfLbl:orderDetail.exportToPdfLbl}}
          <kendo-loader *ngIf="loadingPDF"></kendo-loader>
        </button>
      </div>-->
      <!--<input placeholder="Search in all columns..."
             kendoTextBox
             (input)="onFilterTrackShipment($event.target.value)" class="pwaOrderInquiryDetailsSearch" />-->
    </ng-template>

    <!--<kendo-grid-column media="(max-width: 1024px)" title="Track Shipment">
      <ng-template kendoGridCellTemplate let-dataItem>

        <div class="row mb-2">
          <div class="col-12 descriptionPwa">
            {{dataItem.shipmentId}}- {{dataItem.carrier}}
          </div>
        </div>

        <div class="row">
          <div class="col-sm-4 col-md-4 paddingZero">
            <span class="txt-bold descriptionPwa">{{orderDetailTxt.proNoLbl ? orderDetailTxt.proNoLbl : orderDetail.proNoLbl}}:</span> <span class="float-right-pwa"> {{dataItem.proNo}}</span>
          </div>
          <div class="col-sm-4 col-md-4 paddingZero">
            <span class="txt-bold"> {{orderDetailTxt.noOfBoxesLbl ? orderDetailTxt.noOfBoxesLbl : orderDetail.noOfBoxesLbl}}:</span> <span class="float-right-pwa"> {{dataItem.noOfBoxes}}</span>
          </div>
          <div class="col-sm-4 col-md-4 paddingZero">
            <span class="txt-bold"> {{orderDetailTxt.totalWeightLbl ? orderDetailTxt.totalWeightLbl : orderDetail.totalWeightLbl}}:</span> <span class="float-right-pwa"> {{dataItem.totalWeight}}</span>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-4 col-md-4 paddingZero">
            <span class="txt-bold descriptionPwa">{{orderDetailTxt.billOfLading ? orderDetailTxt.billOfLading : orderDetail.billOfLading}}:</span> <span class="float-right-pwa"> {{dataItem.billOfLoading}}</span>
          </div>
          <div class="col-sm-4 col-md-4 paddingZero">
            <span class="txt-bold">{{orderDetailTxt.shipDateLbl ? orderDetailTxt.shipDateLbl : orderDetail.shipDateLbl}}:</span> <span class="float-right-pwa"> {{dataItem.shipDateUIString | date:'M/dd/yyyy'}}</span>
          </div>
          <div class="col-sm-4 col-md-4 paddingZero"></div>
        </div>

      </ng-template>
    </kendo-grid-column>-->
    <kendo-grid-column *ngFor="let col of gridShipmentSettings.columnsConfig"
                       [field]="col.field"
                       [title]="col.title"
                       [width]="col._width"
                       [filter]="col.filter"
                       [filterable]="col.filterable"
                       [hidden]="col.hidden"
                       [format]="col.format" media="(min-width: 1025px)">
    </kendo-grid-column>
    <ng-template kendoGridNoRecordsTemplate>
    </ng-template>

    <ng-template kendoGridDetailTemplate let-dataItem>
      <kendo-grid [data]="dataItem.items">
        <!--<kendo-grid-column media="(max-width: 1024px)">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div class="row">
              <div class="col-sm-4 col-md-4 paddingZero">
                <span class="txt-bold descriptionPwa">Shipment ID:</span> <span class="float-right-pwa"> {{dataItem.shipmentid}}</span>
              </div>
              <div class="col-sm-4 col-md-4 paddingZero">
                <span class="txt-bold descriptionPwa">Box No:</span> <span class="float-right-pwa"> {{dataItem.boxno}}</span>
              </div>
              <div class="col-sm-4 col-md-4 paddingZero">
                <span class="txt-bold descriptionPwa">Item:</span> <span class="float-right-pwa"> {{dataItem.item}}</span>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-8 col-md-8 paddingZero">
                <span class="txt-bold descriptionPwa">Item Description:</span> <span class="float-right-pwa"> {{dataItem.itemdescription}}</span>
              </div>
              <div class="col-sm-4 col-md-4 paddingZero">
                <span class="txt-bold descriptionPwa">Quantity:</span> <span class="float-right-pwa"> {{dataItem.quantity}}</span>
              </div>

            </div>
          </ng-template>
        </kendo-grid-column>-->
        <kendo-grid-column field="shipmentId" title="Shipment ID" media="(min-width: 1025px)">
        </kendo-grid-column>
        <kendo-grid-column field="boxno" title="Box No" media="(min-width: 1025px)">
        </kendo-grid-column>
        <kendo-grid-column field="itemNumber" title="Item" media="(min-width: 1025px)">
        </kendo-grid-column>
        <kendo-grid-column field="itemDescription" title="Item Description" media="(min-width: 1025px)">
        </kendo-grid-column>
        <kendo-grid-column field="itemWeight" title="Weight" media="(min-width: 1025px)">
          <ng-template kendoGridCellTemplate
                       let-filter
                       let-column="column"
                       let-dataItem
                       media="(min-width: 1025px)">
            <div *ngIf="dataItem.itemWeight && dataItem.itemWeight>0">
              {{dataItem.itemWeight}}
            </div>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="originalQuantity" title="Quantity" media="(min-width: 1025px)">
        </kendo-grid-column>
        <kendo-grid-column field="claimedQuantity" title="Quantity Claimed" media="(min-width: 1025px)">
        </kendo-grid-column>
        <kendo-grid-column field="approvedQuantity" title="Quantity Approved" media="(min-width: 1025px)">
          <ng-template kendoGridCellTemplate
                       let-filter
                       let-column="column"
                       let-dataItem
                       media="(min-width: 1025px)">
            <div *ngIf="claim.statusName!='Pending'">
              {{dataItem.approvedQuantity}}
            </div>
          </ng-template>
        </kendo-grid-column>

        <!--<ng-template kendoGridCellTemplate
                     let-filter
                     let-column="column"
                     let-dataItem
                     media="(min-width: 1025px)"
                     *ngIf="col.field =='qtyToClaim'">
          <div>
            <kendo-numerictextbox [spinners]="false" [decimals]="0"
                                  [min]="0">
            </kendo-numerictextbox>
          </div>
        </ng-template>-->
      </kendo-grid>
    </ng-template>
    <!--<ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
      <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
      <kendo-pager-numeric-buttons [buttonCount]="5"></kendo-pager-numeric-buttons>
      <kendo-pager-info></kendo-pager-info>
      <kendo-pager-next-buttons></kendo-pager-next-buttons>
      <kendo-pager-page-sizes [pageSizes]="[50,75,100]"></kendo-pager-page-sizes>
    </ng-template>-->
  </kendo-grid>
</div>
<br />
<fieldset>
  <legend style="width:auto; margin-bottom: 0px; font-weight: bold; color: #1f497d;"></legend>
  <span><b>Carriers Inspection Report</b></span><br />
  <ul *ngFor="let item of claim.carrierInspectionReports">
    <li>{{item.fileName}}</li>
  </ul>
</fieldset>
<br />
<fieldset>
  <legend style="width:auto; margin-bottom: 0px; font-weight: bold; color: #1f497d;"></legend>
  <span><b>Photos of damage with material in its original Packaging</b></span><br />
  <ul *ngFor="let item of claim.damagedMaterialPhotos">
    <li>{{item.fileName}}</li>
  </ul>
</fieldset>

<div class="d-super-center flex-xs-column flex-sm-column flex-md-row flex-lg-row flex-xl-row" style="text-align: center">
  <button kendoButton
          (click)="goBack()"
          class="m-3 clearKendoButton btn btn-success" style="margin: 0 auto;">
    Back
  </button><br />
</div>




